import { PageLayout } from "@ezmid/components-library/";
import { useTranslation } from "react-i18next";

import { CourseAddPageContent } from "../organisms/CourseAddPageContent";

export function CourseAddPage() {
  const { t } = useTranslation();

  return (
    <PageLayout title={t("app.page.courses.heading")}>
      <CourseAddPageContent />
    </PageLayout>
  );
}
